import reducers from './reducers';
import history from './util/history';
import { routerMiddleware } from 'connected-react-router';
import customAppsMiddleware from './middleware/customAppsMiddleware';
import configureCommonStore from '@lifeomic/phc-web-toolkit/src/redux';

const configureStore = () =>
  configureCommonStore(undefined, reducers(history), [
    routerMiddleware(history),
    customAppsMiddleware,
  ]);

export default configureStore;
